import type { Operation } from '@apollo/client';
import type { ReactNode } from 'react';

import { ApolloClient, ApolloLink, ApolloProvider, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const authLink = setContext((_, { headers }: { headers?: Record<string, string> }) => {
  const token = localStorage.getItem('token');

  const nextHeaders = {
    ...headers,
  };

  if (token) {
    nextHeaders.authorization = `Bearer ${token}`;
  } else {
    delete nextHeaders.authorization;
  }

  return {
    headers: nextHeaders,
  };
});

const path: string = import.meta.env.VITE_PC_GQL_PATH || '';

const direct_uri: string = import.meta.env.VITE_APP_URI || '';

const proxy_uri: string = import.meta.env.VITE_VGS_INBOUND_URI || '';

const directLink: ApolloLink = authLink.concat(createHttpLink({ uri: direct_uri + path }));

const proxyLink: ApolloLink = authLink.concat(createHttpLink({ uri: proxy_uri + path }));

const shouldUseProxy = (operation: Operation): boolean => {
  const sensitive: boolean = operation.getContext().containsSensitiveData;

  if (sensitive && proxy_uri) return true;

  if (sensitive)
    console.error(
      'Making PII request without setting REACT_APP_VGS_INBOUND_URI.\nSensitive fields will not be tokenized',
    );

  return false;
};

const apolloClient = new ApolloClient({
  link: ApolloLink.split(shouldUseProxy, proxyLink, directLink),
  cache: new InMemoryCache(),
});

export const ApolloProviderWrapper = (props: { children: ReactNode }) => {
  return <ApolloProvider client={apolloClient}>{props.children}</ApolloProvider>;
};
